import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import api from "../services/api";
import { toast } from "react-toastify";

import "../styles/floatingForm.css";

const UpdateUser = () => {

  const navigate = useNavigate();

  const { id } = useParams();

  // --------------------------------------------------
  // FORM
  // --------------------------------------------------

  const [employeeId, setEmployeeId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [errors, setErrors] = useState({});


  // --------------------------------------------------
  // FETCH USER
  // --------------------------------------------------

  const fetchUserDetails = async () => {

    try {

      const response = await api.get(
        `/adminusers/get/${id}`
      );

      const userData = response.data.data;

      setEmployeeId(
        userData?.emplyid || ""
      );

      setName(
        userData?.name || ""
      );

      setEmail(
        userData?.email || ""
      );

      setPassword(
        userData?.password || ""
      );

    } catch (error) {

      console.error(
        "Error fetching user:",
        error
      );

      toast.error(
        "Failed to load user details"
      );

    }

  };


  useEffect(() => {

    if (id) {
      fetchUserDetails();
    }

  }, [id]);


  // --------------------------------------------------
  // CANCEL / BACK
  // --------------------------------------------------

  const handleCancel = () => {

    navigate("/users");

  };


  // --------------------------------------------------
  // SUBMIT
  // --------------------------------------------------

  const handleSubmit = async (e) => {

    e.preventDefault();

    const newErrors = {};

    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


    if (!employeeId?.trim()) {
      newErrors.employeeId =
        "Employee Id is required";
    }

    if (!name?.trim()) {
      newErrors.name =
        "Name is required";
    }

    if (!email?.trim()) {

      newErrors.email =
        "Email is required";

    } else if (!emailRegex.test(email)) {

      newErrors.email =
        "Invalid email format";

    }

    if (!password?.trim()) {

      newErrors.password =
        "Password is required";

    }


    if (Object.keys(newErrors).length > 0) {

      setErrors(newErrors);

      toast.error(
        "Please fill all required fields correctly"
      );

      return;

    }


    setErrors({});


    const formData = new FormData();

    formData.append(
      "emplyid",
      employeeId
    );

    formData.append(
      "name",
      name
    );

    formData.append(
      "email",
      email
    );

    formData.append(
      "password",
      password
    );


    try {

      const response = await api.post(
        `/adminusers/edit/${id}`,
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data"
          }
        }
      );


      if (response.status === 200) {

        toast.success(
          "User Updated successfully!"
        );

        navigate("/users");

      } else {

        toast.error(
          "Failed to update User"
        );

      }

    } catch (error) {

      console.error(
        "Error updating user:",
        error
      );

      toast.error(
        "Error updating User"
      );

    }

  };


  return (
    <div className='floating-form-container' >
      <div className="heading">
        <h2>User Details</h2>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-container">

          {/* Basic Info */}
          <div className="section-1">
            

            <div className="input-container-floating-form wid-50">
              <label>Employee Id</label>
              <input
                type="text"
                className={`form-control ${errors.employeeId ? 'is-invalid' : ''}`}
                value={employeeId}
                onChange={(e) => setEmployeeId(e.target.value)}
                placeholder="Enter Employee Id"
                />
                {errors.employeeId && <span className='text-danger small'>{errors.employeeId}</span>}

            </div>

            <div className="input-container-floating-form wid-50">
              <label>Name</label>
              <input
                type="text"
                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter Name"
                />
                {errors.name && <span className='text-danger small'>{errors.name}</span>}

            </div>

            <div className="input-container-floating-form wid-50">
              <label>Email</label>
              <input
                type="email"
                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Email"
                />
                {errors.email && <span className='text-danger small'>{errors.email}</span>}

            </div>

            <div className="input-container-floating-form wid-50">
              <label>Password</label>
              <input
                type="password"
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Password"
                />
                {errors.password && <span className='text-danger small'>{errors.password}</span>}

            </div>

          </div>

            <div className="form-btn-container">
            <button type='submit'>Update User</button>
            <button type='button' onClick={handleCancel}>Cancel</button>
            </div>

        </div>



      </form>
    </div>
  );
};

export default UpdateUser;
